var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5684 7.64551C17.5684 7.37305 17.4541 7.10938 17.252 6.91602L11.4775 1.1416C11.249 0.921875 11.0117 0.825195 10.7656 0.825195C10.2031 0.825195 9.79883 1.2207 9.79883 1.75684C9.79883 2.03809 9.91309 2.27539 10.0889 2.45117L12.0664 4.45508L14.6152 6.78418L12.5762 6.66113H1.92383C1.33496 6.66113 0.930664 7.06543 0.930664 7.64551C0.930664 8.2168 1.33496 8.62109 1.92383 8.62109H12.5762L14.6152 8.49805L12.0664 10.8271L10.0889 12.8311C9.91309 13.0068 9.79883 13.2441 9.79883 13.5254C9.79883 14.0615 10.2031 14.457 10.7656 14.457C11.0117 14.457 11.249 14.3604 11.46 14.1582L17.252 8.36621C17.4541 8.17285 17.5684 7.90918 17.5684 7.64551Z",
    fill: "#F2F4F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.715e1b1fe19bc9c4b4a94ba42a002327.svg";
export { ForwardRef as ReactComponent };